import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../components/PrimereactComponents';
import AnalysesNavList from '../../components/analysesNav/AnalysesNavList';
import Intro from '../../components/common/Intro/Intro';

function Analyses() {
    const { t } = useTranslation(['analyses', 'translation']);

    return (
        <>
            <Intro title={t('Analyses', { ns: 'translation' })} description={t('title-tooltip')} />
            <Tooltip target='.custom-target-icon' />
            <AnalysesNavList variant='analyses' />
            <Outlet />
        </>
    );
}

export default Analyses;
